import { createActions } from "redux-actions";

export const {
  setWorkspaceOrderGroupCandidates,
  setWorkspaceOrderGroupCandidatesLoading,
} = createActions({
  SET_WORKSPACE_ORDER_GROUP_CANDIDATES: ({ items }) => ({ items }),
  SET_WORKSPACE_ORDER_GROUP_CANDIDATES_LOADING: ({ loading }) => ({ loading }),
});
